/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_LoadingInputs */

const en_us2_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your retrospective`)
};

const pt_br2_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando sua retrospectiva`)
};

const es_419_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando tu resumen`)
};

const pt_pt2_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar a tua retrospetiva`)
};

const fr_fr2_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de ton bilan`)
};

const de_de2_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Rückblick wird geladen`)
};

const it_it2_wrapped_loading = /** @type {(inputs: Wrapped_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del tuo riepilogo`)
};

/**
* | output |
* | --- |
* | "Loading your retrospective" |
*
* @param {Wrapped_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_loading = /** @type {((inputs?: Wrapped_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_loading(inputs)
	if (locale === "es-419") return es_419_wrapped_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_loading(inputs)
	if (locale === "de-DE") return de_de2_wrapped_loading(inputs)
	if (locale === "it-IT") return it_it2_wrapped_loading(inputs)
	return en_us2_wrapped_loading(inputs)
});
export { wrapped_loading as "wrapped.loading" }